import { toCurrencyString } from '@modules/bcm/@shared/pipes/dynamic-currency.pipe';
import { resolveUnitTranslationKey } from '@shared/functions/resolve-unit-translation-key';
import { IProduct } from '@shared/models/product';
import { IUnit } from '@shared/models/unit';

export function formatProductUnitLabel(
    unit: IUnit | null | undefined,
    translate: (key: string) => string = key => key,
): string {
    const unitKey = resolveUnitTranslationKey(unit);
    if (unitKey) {
        return translate(`${unitKey}.name`);
    }
    return unit?.name || '';
}

export function formatProductAutocompleteLabel(
    product: IProduct | string | null | undefined,
    translate: (key: string) => string = key => key,
): string {
    if (!product || typeof product === 'string') {
        return typeof product === 'string' ? product : '';
    }

    if (!product.name) {
        return '';
    }

    const priceLabel = toCurrencyString(product.price, '1.2-2');
    const unitLabel = formatProductUnitLabel(product.unit, translate);

    if (priceLabel && unitLabel) {
        return `${product.name} | ${priceLabel} / ${unitLabel}`;
    }
    if (priceLabel) {
        return `${product.name} | ${priceLabel}`;
    }

    return product.name;
}
